import {
  hwcloud,
  protoUrl,
  certUrl,
  parentUrl,
  financeUrl,
  cooperativeService,
  bpsUrl
} from '@common/url-conf'

import {
  post
} from '@common/axios'

export const accountApi = {
  // 获取收件地址列表
  queryAddressList: p => post(`${cooperativeService}/api/v1/partner/address/querypage`, p),
  // 新增收件地址
  addAddress: (p, h) => post(`${cooperativeService}/api/v1/partner/address/save`, p, {
    notRepeatService: cooperativeService
  }),
  // 修改收件地址
  updateAddress: (p, h) => post(`${cooperativeService}/api/v1/partner/address/update`, p, {
    notRepeatService: cooperativeService
  }),
  // 删除收件地址
  deleteAddress: id => post(`${cooperativeService}/api/v1/partner/address/delete?id=${id}`, {}, {
    notRepeatService: cooperativeService
  }),
  // 收件地址设为默认
  setDefaultAddress: id => post(`${cooperativeService}/api/v1/partner/address/default?id=${id}`, {}, {
    notRepeatService: cooperativeService
  }),

  //根据customerCode查询客户企业信息 , 是否实名认证
  clientQueryBaseInfo: p => post(`${cooperativeService}/api/v1/account/queryaccount`),
  //保存个人信息
  updatePersonInfo: p => post(`${cooperativeService}/api/v1/account/editbaseinfo`, p, {
    notRepeatService: cooperativeService
  }),
  //账户名修改
  updateLoginName: name => post(`${cooperativeService}/api/v1/account/editloginname?loginName=${name}`, {}, {
    notRepeatService: cooperativeService
  }),
  //绑定邮箱
  setEmail: p => post(`${cooperativeService}/api/v1/account/bindemail`, p, {
    notRepeatService: cooperativeService
  }),
  //修改邮箱
  updateEmail: p => post(`${cooperativeService}/api/v1/account/editemail`, p, {
    notRepeatService: cooperativeService
  }),
  // 修改手机号
  updatePhone: p => post(`${cooperativeService}/api/v1/account/editphone`, p, {
    notRepeatService: cooperativeService
  }),
  //认证手机号码回显
  getPhoneNum: () => post(`${certUrl}/api/v1/enterpriserealnamechangecontroller/getPhoneNum`),
  //基本信息
  queryClientUserInfo: () => post(`${cooperativeService}/api/v1/account/queryaccountinfo`),
  //查看账号类型
  queryAccountType: () => post(`${cooperativeService}/api/v1/partner/viewAccountType`),




  // 证件认证数据保存
  clientCredentSave: p => post(`${cooperativeService}/api/v1/partner/authencert/businesspaperscertificate`, p),
  // 下载授权书模板
  clientDownloadModel: (type, p, h) => post(`${certUrl}/api/v1/authencert/downloadAutoDoc?templateType=${type}`, {}, p, h),
  // 获取协议
  findNewestByProtocolCode: p => post(`${protoUrl}/protocol/findNewestByProtocolCode`, p),

  // 企业证件类型 可选项查询
  clientQueryCredentOptions: p => post(`${certUrl}/dict/findByCode?dictCode=${p.typeCode}`),
  // 企业同一证件，最大认证次数6次
  clientCredentMax: p => post(`${certUrl}/api/v1/authencert/authEntCertforentIdCard`, p),
  // 证件认证根据主键查询数据（回显）
  clientQueryData: p => post(`${cooperativeService}/api/v1/partner/authencert/findauthencertbyid?id=${p}`),
  // 更新企业证件认证( 客户端保存企业认证信息调用 证件认证数据保存 接口 )
  clientUpdateCredentAuth: p => post(`${cooperativeService}/api/v1/partner/authencert/updateauthencert`, p,{
    notRepeatService: cooperativeService
  }),
  // 企业账户认证 收件地址 可选项查询
  clientAddressOptions: p => post(`${certUrl}/dict/findByCode?dictCode=${p.dictCode}`, p),
  //取消认证
  clientCancelAuthBlank: authId => post(`${cooperativeService}/api/v1/partner/authenbank/cancelauthenbank?authId=${authId}`),
  //查询认证次数
  clientQueryAuthTime: p => post(`${certUrl}/api/v1/authenbank/authbanknumber`, p),

  // 银行 企业认证
  // 根据用户code获取银行对公账号认证信息
  clientAuthEntBankforCode: p => post(`${cooperativeService}/api/v1/partner/authenbank/authentbankforpartnercode`, p),
  // 企业对公账户信息保存
  clientSaveAuthEnbank: p => post(`${cooperativeService}/api/v1/partner/authenbank/saveauthenbank`, p),
  // 企业对公账户验证码校验
  clientValidationVerifyCode: p => post(`${cooperativeService}/api/v1/partner/authenbank/validationverifycode`, p,{
    notRepeatService: cooperativeService
  }),

  // 企业变更认证
  clientSaveEntInfo: p => post(`${cooperativeService}/api/v1/enterpriserealnamechange/saveentinfo`, p),
  // 企业变更认证前 发送短信验证码
  sendCaptcha: p => post(`${cooperativeService}/api/v1/enterpriserealnamechange/sendCaptcha?changeType=${p}`),
  // 验证码校验
  checkCaptcha: (p, changeType) => post(`${cooperativeService}/api/v1/enterpriserealnamechange/checkCaptcha?captcha=${p}&changeType=${changeType}`),
  // 企业主体变更 申请表模板下载
  clientDownloadEntTemplate: (type, h, p) => post(`${certUrl}/api/v1/enterpriserealnamechangecontroller/downloadEntTemplate?templateType=${type}`, {}, h, p),
  // 根据用户选中数据查询 开户支行
  queryAuthBankBranch: p => post(`${certUrl}/api/v1/authenbank/querysybradtay`, p),
  // 查看认证状态
  viewAuthentication: p => post(`${certUrl}/api/v1/authenbank/viewAuthentication`, p),
  // 查看认证状态（已认证状态时显示一直是已认证，包括进行实名变更等）
  viewAuthenticationInfo: p => post(`${certUrl}/api/v1/authenbank/viewAuthenticationInfo`, p),
  // 回显 企业已上传证件认证信息
  reviewAuthInfom: p => post(`${cooperativeService}/api/v1/enterpriserealnamechange/queryEntUploadedInfo?id=${p}`),
  // 修改证件已上传且变更认证失败企业信息
  reSaveAuthInfom: p => post(`${cooperativeService}/api/v1/enterpriserealnamechange/updateEntUploadedInfo`, p),




  // ---- 陈杨start ----
  //绑定多云发送验证码
  sendcaptchaforbindcloud:p=>post(`${cooperativeService}/api/v1/captcha/sendcaptchaforbindcloud`, p,{
    notRepeatService: cooperativeService
  }),
  // 2020-8-27 新的绑定多云账号接口，原有不动
  userBindCloud: p => post(`${cooperativeService}/api/v1/partner/bpcloud/userbindcloud`, p, {
    notRepeatService: cooperativeService
  }),
  // 查询云厂商关联的二级渠道
  getIndirectPartner: (p) => post(`${hwcloud}/api/v1/partnermanage/queryindirectpartner`, p),
  // 获取未绑定云的bp
  getNotBoundCloud: (p, header) => post(`${cooperativeService}/api/v1/partner/bpcloud/querybpwithoutcloud`, p, header),
  // ---- 陈杨end ----

  //渠道修改实名认证状态（主动触发修改）
  updateauth: userCode => post(`${cooperativeService}/api/v1/cooperative/certification/updateauth?userCode=${userCode}`),

  //查询基础商业信息
  queryBusinessInfo: id => post(`${cooperativeService}/api/v1/commercial/querybase?id=${id}`),
  //保存商业信息
  saveBusinessInfo: p => post(`${cooperativeService}/api/v1/commercial/save`, p, {
    notRepeatService: cooperativeService
  }),
  //上传附件
  uploadFile:p => post(`${hwcloud}/obs/uploadbusinessfile`, p, {
    notRepeatService: hwcloud
  }),
  // OBS导出记录 下载
  downloadRecords: (params, h, op) => post(`${hwcloud}/obs/downloadFile?objectKey=${params.url}`, params, h, op),
  //查询商业认证状态
  queryBusinessStatu:()=>post(`${cooperativeService}/api/v1/commercial/querybusinessstatus`),

  //商业认证详情
  queryCommercialDetail: p => post(`${cooperativeService}/api/v1/commercial/querycommercialdetail`, p),
  //历史认证列表
  queryCommercialList: p => post(`${cooperativeService}/api/v1/commercial/querycommercialhistory`,p),
  //历史认证详情
  queryCommercialHistoryDetail: p => post(`${cooperativeService}/api/v1/commercial/querycommercialdetail?commercialCode=${p}`),
  //修改联系人信息
  updateFinancialContact: p => post(`${cooperativeService}/api/v1/commercial/updatefinancialcontact`, p),
  //通过渠道编码查询是否存在发票审核中记录
  queryIncentive: partnerCode => post(`${parentUrl}/api/v1/partner/inspire/auditing`),
  //查询未开票激励
  queryInvoiceApplyOfBizInfo: p => post(`${financeUrl}/api/v1/charge/incentive/apply/queryInvoiceApplyOfBizInfo`, p),
   //查询待审请激励列表
   queryIncentiveStatOfBizInfo: p => post(`${financeUrl}/api/v1/chargeincentivestat/queryIncentiveStatOfBizInfo`, p),
   //撤回未开票激励
   queryIncentiveStatOfBizInfocancel: applyNo => post(`${financeUrl}/api/v1/charge/incentive/apply/${applyNo}/cancel`),
   //去查看未开票激励
   queryIncentiveStatOfBizInfoview: applyNo => post(`${financeUrl}/api/v1/charge/incentive/apply/${applyNo}/view`),
  // 查询行业信息
   queryIndustryInfo: p => post(`${bpsUrl}/api/v1/industryInfo/queryEnterpriseIndustryInfo`, p),

   queryUcmEnInfo: p => post(`${bpsUrl}/api/v1/ucm/queryUcmInfo`, p),

};
//api/v1/commercial/updatefinancialcontact


// WEBPACK FOOTER //
// ./src/modules/user-center/account/services.js